<template>
  <div id="app">
    <main>
      <router-view/>
    </main>
  </div>
</template>

<style lang="sass">

@import "./sass/basic/main.sass"

</style>

<script>

export default {
  name: 'App',
  components: {

  },
  methods: {

  },
  created(){
    // alert(1)
  }
}

</script>
